import { Recipient } from '../../../../models/parcelDeliveryMiles';
import { getFullUserAddress } from '../../../../utils/generic/generic.utils';
import {
  ReceiverData,
  ReceiverName,
  ReceiverNotes,
} from './receiver-card.styles';

interface Props {
  receiver: Recipient;
}

const ReceiverCard = ({ receiver }: Props) => (
  <>
    <ReceiverName>
      {[receiver.first_name, receiver.middle_name, receiver.last_name]
        .filter(Boolean)
        .join(' ')}
    </ReceiverName>
    {receiver?.phone?.phone_number && (
      <ReceiverData>{receiver?.phone?.phone_number}</ReceiverData>
    )}
    {receiver?.email && <ReceiverData>{receiver?.email}</ReceiverData>}
    {receiver?.address && (
      <ReceiverData>{getFullUserAddress(receiver?.address)}</ReceiverData>
    )}
    {receiver?.address?.note && (
      <ReceiverNotes>{receiver?.address?.note}</ReceiverNotes>
    )}
  </>
);

export default ReceiverCard;
